<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <form #dataServiceForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Element Name*</label>
        <input class="form-control" type="text" name="element" [(ngModel)]="rowData.ELEMENT_NAME" required>
        @if (dataServiceForm.form?.get('element')?.invalid && dataServiceForm.form?.get('element')?.touched) {
<span class="form-error-container">
          Element name is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Submission ID more than 600</label>
        <input class="form-control" type="number" name="subwith600" [(ngModel)]="rowData.SUBMISSION_ID_MORE_THAN_600">
      </div>
    </div>
  </form>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
